import type { CityConfig } from "../city-template/types";

export const huronConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Huron",
  state: "South Dakota",
  stateAbbr: "SD",
  slug: "huron",
  route: "/huron",
  title: "Emergency Passport Huron, SD — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Huron, SD — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Huron residents, South Dakota State Fair visitors, Beadle County agribusiness professionals, and central South Dakota travelers.",
  h1: "Emergency & Expedited Passport Services in Huron, SD",
  heroSubtitle: "South Dakota State Fair international exhibitor registration this month and need a passport? Beadle County agribusiness trip to Canada or Germany in two weeks? Huron family planning a once-in-a-lifetime overseas vacation? We help Huron residents — from State Fair organizers and agricultural professionals to Beadle County families and central South Dakota travelers — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Aerial%20view%20of%20the%20South%20Dakota%20State%20Fairgrounds%20in%20Huron%20South%20Dakota%20during%20the%20summer%20fair%20season%20with%20colorful%20exhibition%20halls%2C%20agricultural%20display%20barns%2C%20the%20grandstand%20arena%2C%20and%20carnival%20midway%20rides%20under%20a%20bright%20blue%20prairie%20sky%2C%20golden%20wheat%20fields%20stretching%20to%20the%20horizon%2C%20warm%20afternoon%20sunlight%20illuminating%20the%20fairground%20buildings%20and%20surrounding%20central%20South%20Dakota%20farmland&width=1800&height=700&seq=huron-hero-2026&orientation=landscape",
  heroImageAlt: "South Dakota State Fairgrounds in Huron South Dakota during summer fair season",
  geoPosition: "44.3633;-98.2142",
  geoPlacename: "Huron, South Dakota",
  lastModified: "2026-06-15",
  regionalAgency: {
    name: "Chicago Passport Agency",
    address: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
    distance: "Located approximately 350 miles east of Huron via US-14 and I-90 — appointments required, typically booked 2+ weeks out",
  },
  nearbyCitiesZips: [
    { name: "Huron", zips: "57350" },
    { name: "Wolsey", zips: "57384" },
    { name: "Wessington", zips: "57381" },
    { name: "Cavour", zips: "57324" },
    { name: "Virgil", zips: "57379" },
    { name: "Alpena", zips: "57312" },
    { name: "Miller", zips: "57362" },
    { name: "Redfield", zips: "57469" },
    { name: "De Smet", zips: "57231" },
    { name: "Woonsocket", zips: "57385" },
    { name: "Iroquois", zips: "57353" },
    { name: "Hitchcock", zips: "57348" },
    { name: "Tulare", zips: "57476" },
    { name: "Carpenter", zips: "57322" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Emergency Processing", desc: "Reserved courier access to the Minneapolis Passport Agency — as fast as 24 hours for Huron-area travelers with immediate departures." },
    { icon: "ri-plant-line", title: "Agribusiness Travel Ready", desc: "Beadle County's strong agricultural economy drives international equipment sourcing, trade shows, and supplier meetings. We understand the ag calendar." },
    { icon: "ri-building-2-line", title: "State Fair International Travel", desc: "SD State Fair exhibitors, international livestock judges, and agricultural exchange programs create unique passport needs. We handle the paperwork." },
    { icon: "ri-flight-takeoff-line", title: "Central SD Air Access", desc: "Huron Regional Airport (HON), Aberdeen Regional (ABR, 90 mi north), and Sioux Falls Regional (FSD, 120 mi southeast) provide multiple airport options." },
  ],
  internalLinks: [
    { name: "Fast passport services in Sioux Falls, SD", route: "/sioux-falls" },
    { name: "Expedited passport in Rapid City, SD", route: "/rapid-city" },
    { name: "Quick passport services in Mitchell, SD", route: "/mitchell" },
    { name: "Urgent passport services in Aberdeen, SD", route: "/aberdeen-sd" },
    { name: "South Dakota passport services overview", route: "/south-dakota" },
  ],
  fpcOfficeAddress: "230 S Dearborn St, Suite 380, Chicago, IL 60604",
  fpcOfficeNote: "Fast Passport Center serves Huron via secure registered courier with direct access to the Minneapolis Passport Agency at 212 3rd Ave S, Minneapolis. Our registered couriers hand-deliver your documents — meaning you get faster results without the 350-mile drive. Huron residents can ship from any UPS Store, FedEx Office, or post office location across Beadle County.",
  fpcOfficeDistance: "Serving Huron, Wolsey, Wessington, Cavour, Virgil, Alpena, Miller, Redfield, and all Beadle County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Huron and Beadle County. From the historic downtown district to the South Dakota State Fairgrounds, from the agricultural equipment dealerships to the surrounding farming communities — we serve all of Beadle County and adjacent areas in central South Dakota. Our courier service eliminates the need to drive nearly six hours to the Minneapolis Passport Agency or wait for a rural post office appointment.",
  nearbyCitiesIntro: "We serve Huron and surrounding communities including Wolsey, Wessington, Cavour, Virgil, Alpena, Miller, Redfield, De Smet, and Woonsocket. We also serve travelers departing from Huron Regional Airport (HON), Aberdeen Regional Airport (ABR), and Sioux Falls Regional Airport (FSD) who need expedited passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Huron as simple as possible — with the efficiency and reliability State Fair exhibitors, agribusiness professionals, and Beadle County families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you with our best price guarantee. Most Huron travelers start online and ship documents overnight — no office visit required for most services.",
  mistakesIntro: "Huron travelers encounter unique passport issues — everything from State Fair season delays to agricultural trade show visa timelines to Canada cross-border requirements. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Huron travelers — from State Fair organizers to Beadle County farmers to central South Dakota families — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Huron, SD? Here are the most common ones we hear from Beadle County travelers.",
  statePageRoute: "/states/south-dakota",
  statePageName: "South Dakota",
  servicesIntro: "Whether you need a renewal before a Canadian farm equipment expo, an emergency passport for a State Fair international exhibitor exchange, or a first-time passport for a Beadle County family vacation — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier (not a reseller), we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party passport courier resellers.",
  dmvWebsite: "https://dps.sd.gov/driver-licensing",
  dmvLabel: "South Dakota DPS Driver Licensing — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns and budget fights", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Agribusiness trade show in Germany in 3 days? State Fair international exhibitor exchange leaving this week? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Huron-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Huron residents renew fast — no agency visit required for most renewals. Perfect for Beadle County ag professionals, State Fair organizers, and Huron families.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Huron residents through every step — from first-time travelers to farm families — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your ag trade show or international trip is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your family trip abroad or State Fair exchange program stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations. Common for Huron residents after name changes.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for Huron agribusiness executives and State Fair international organizers who travel while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a significantly damaged passport is faster than you think. We guide Huron-area travelers through the process so your international itinerary stays on track.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. We expedite passport card applications with the same courier service as book passports.",
      bullets: ["Wallet-size convenience", "Land and sea travel to nearby destinations", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Huron SD", description: "Urgent passport processing for Huron South Dakota travelers with immediate departure needs." },
    { name: "Expedited Passport Renewal Huron SD", description: "Fast passport renewal for Huron South Dakota residents with a previously-issued passport." },
    { name: "First-Time Passport Huron SD", description: "New passport application services for Huron South Dakota residents applying for their first passport." },
    { name: "Child Passport Huron SD", description: "Minor passport services for Huron South Dakota families with children under 16." },
    { name: "Name Change Passport Huron SD", description: "Passport name correction after marriage, divorce, or legal name changes for Huron residents." },
    { name: "Second Passport Huron SD", description: "Second passport services for Huron agribusiness executives and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Ron P.",
      location: "Farmer, Beadle County",
      rating: 5,
      text: "I needed to go to the Canadian Farm Progress Show in Regina and my passport expired during planting season. Fast Passport Center got it renewed in 5 days. Made it to Saskatchewan for the whole show.",
      service: "Emergency Passport Renewal",
    },
    {
      name: "Susan M.",
      location: "State Fair Organizer, Huron",
      rating: 5,
      text: "We host international livestock judges at the SD State Fair and I needed a passport quickly for a pre-fair exchange trip to Australia. They expedited my renewal in 4 business days. Incredible turnaround.",
      service: "Passport Renewal",
    },
    {
      name: "The Berg Family",
      location: "Huron",
      rating: 5,
      text: "We booked a family trip to Norway to visit relatives and realized all three of us needed passport renewals. They processed everything together and all three arrived on time. Such a relief!",
      service: "Family Passport Renewals",
    },
    {
      name: "Dale W.",
      location: "Ag Equipment Dealer, Huron",
      rating: 5,
      text: "Second time using Fast Passport Center for international equipment sourcing in Germany. They understand the ag industry timeline and always deliver. Best service for central South Dakota.",
      service: "Passport Renewal",
    },
  ],
  facilities: [
    {
      id: "huron-1",
      name: "Huron Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "410 Dakota Ave S",
      city: "Huron",
      state: "SD",
      zip: "57350",
      phone: "(605) 352-9261",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Downtown Huron",
      website: "https://tools.usps.com/find-location.htm?location=1368378",
      websiteLabel: "USPS Location",
      notes: "Primary passport acceptance facility serving Huron and Beadle County. Passport photos available. Appointment strongly recommended — limited walk-in capacity especially during State Fair season (August–September).",
      icon: "ri-mail-line",
    },
    {
      id: "huron-2",
      name: "Beadle County Clerk of Courts",
      type: "County Clerk Passport Acceptance",
      address: "450 3rd St SW",
      city: "Huron",
      state: "SD",
      zip: "57350",
      phone: "(605) 353-8400",
      hours: "Mon–Fri 8:00 AM – 5:00 PM",
      distance: "Beadle County Courthouse",
      website: "https://beadle.sdcounties.org/",
      websiteLabel: "Beadle County",
      notes: "County clerk office offering passport acceptance services. Convenient alternative to the post office. Call ahead to confirm clerk availability and document requirements.",
      icon: "ri-government-line",
    },
    {
      id: "huron-3",
      name: "Miller Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "120 W 2nd St",
      city: "Miller",
      state: "SD",
      zip: "57362",
      phone: "(605) 853-2491",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Miller — 32 miles northwest",
      website: "https://tools.usps.com/find-location.htm?location=1368405",
      websiteLabel: "USPS Location",
      notes: "Alternative acceptance facility for Hand County residents and northwestern Beadle County. Limited hours — call ahead to confirm availability.",
      icon: "ri-mail-line",
    },
    {
      id: "huron-4",
      name: "Redfield Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "20 E 7th Ave",
      city: "Redfield",
      state: "SD",
      zip: "57469",
      phone: "(605) 472-0771",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Redfield — 38 miles north",
      website: "https://tools.usps.com/find-location.htm?location=1368451",
      websiteLabel: "USPS Location",
      notes: "Alternative acceptance facility for Spink County residents and northern Beadle County. Passport photos available. Appointment recommended.",
      icon: "ri-mail-line",
    },
    {
      id: "huron-5",
      name: "Aberdeen Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "1020 S 5th St",
      city: "Aberdeen",
      state: "SD",
      zip: "57401",
      phone: "(605) 226-2011",
      hours: "Mon–Fri 9:00 AM – 4:30 PM (appointment required)",
      distance: "Aberdeen — 90 miles north via US-281",
      website: "https://tools.usps.com/find-location.htm?location=1368150",
      websiteLabel: "USPS Location",
      notes: "Larger acceptance facility serving northeastern South Dakota. Full photo services and more appointment availability than smaller rural post offices. Near Aberdeen Regional Airport (ABR).",
      icon: "ri-mail-line",
    },
    {
      id: "huron-6",
      name: "Mitchell Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "200 E 5th Ave",
      city: "Mitchell",
      state: "SD",
      zip: "57301",
      phone: "(605) 996-7711",
      hours: "Mon–Fri 9:00 AM – 4:00 PM (appointment required)",
      distance: "Mitchell — 55 miles south via SD-37",
      website: "https://tools.usps.com/find-location.htm?location=1368406",
      websiteLabel: "USPS Location",
      notes: "Alternative acceptance facility for Davison County. Passport photos available. Convenient for southern Beadle County residents headed toward Sioux Falls.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 350 miles to Minneapolis Passport Agency", fpc: "Most Huron travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "SD-Specific Guidance", agency: "Generic — no State Fair, agribusiness, or central SD expertise", fpc: "Full agribusiness/State Fair/Beadle County knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "State Fair Season Rush",
      description: "Huron residents often attempt passport processing during August–September State Fair season when post office availability is at its lowest. Plan outside the Fair window or use our expedited courier to bypass the local bottleneck.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Huron applicants often attempt the simpler renewal form when their passport was issued at 15 or younger. A rejected form costs 1–2 weeks. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations",
      description: "Many Huron pharmacy and retail store photos fail State Department standards. We catch this in review before it causes a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Missing Canadian Equipment Expo Visa",
      description: "Beadle County farmers attending Canadian agricultural expos sometimes assume a passport is all they need. Some events require business visitor documentation beyond a passport. We help identify these requirements early.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Central SD Mail Transit Delays",
      description: "Huron's central South Dakota location means USPS mail to processing centers takes 1–2 extra days compared to eastern SD cities. We always use overnight shipping to eliminate this transit penalty.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home, office, or farm office." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Huron clients ship from home — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 350 miles to Minneapolis or wait at a rural post office in central South Dakota." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Huron?", a: "We offer Huron-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Do I need to visit an office in Huron?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (the Huron post office or Beadle County clerk), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Huron address." },
    { q: "Where can I get passport acceptance in Huron?", a: "Huron has passport acceptance at the Main Post Office (410 Dakota Ave S) and the Beadle County Clerk of Courts (450 3rd St SW). Nearby options include post offices in Miller, Redfield, Aberdeen, and Mitchell." },
    { q: "How far is the nearest passport agency from Huron?", a: "The Minneapolis Passport Agency (212 3rd Ave S, Minneapolis, MN) is approximately 350 miles east via US-14 and I-90. It requires appointments for life-or-death emergencies only. For travel within 3–14 days, our registered courier service is the fastest legally available channel without the nearly six-hour drive." },
    { q: "Can you help with passports for the SD State Fair international program?", a: "Yes. The South Dakota State Fair regularly hosts international livestock judges, agricultural exchange participants, and exhibitors from Canada, Australia, and Europe. We can expedite passports for State Fair staff, organizers, and exchange participants with international travel needs." },
    { q: "What documents do Huron applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Huron-specific checklist." },
    { q: "Can I get a passport photo in Huron?", a: "Yes — the Huron Main Post Office offers passport photos on-site. Additional photo locations include Lewis Drug, Walmart, and Walgreens. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "What airport should I use for international travel from Huron?", a: "Huron Regional Airport (HON) serves general aviation. For commercial flights, Aberdeen Regional Airport (ABR) is 90 miles north and Sioux Falls Regional Airport (FSD) is 120 miles southeast — both connect to MSP, ORD, and DEN international gateways." },
    { q: "How do I check my Huron passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Huron to final return shipping typically matches your chosen speed tier." },
    { q: "Can Beadle County farmers get help with Canadian ag expo passports?", a: "Yes. We regularly assist Beadle County farmers and agribusiness professionals with expedited passports for Canadian agricultural expos including Canada's Farm Progress Show (Regina) and Ag in Motion (Saskatoon). We understand the ag calendar and can coordinate processing around show dates." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Huron Residents",
    intro: "Huron's position as central South Dakota's agricultural and fair hub with limited local air service creates unique passport timing challenges. Here's what Huron travelers need to know.",
    cards: [
      {
        icon: "ri-plant-line",
        title: "Agricultural Trade & Canadian Farm Shows",
        subtitle: "Beadle County's farming economy drives international agribusiness travel",
        description: "Huron is surrounded by some of South Dakota's most productive agricultural land. Beadle County farmers and equipment dealers regularly attend Canada's Farm Progress Show in Regina, Saskatchewan (approximately 550 miles north) and Ag in Motion near Saskatoon. International equipment sourcing trips to Germany, Italy, and the Netherlands are also common. The agricultural calendar — planting in April–May, harvest in September–October — creates narrow windows for international travel.",
        tip: "Farmers should check passport validity during the winter off-season (December–February) when the ag calendar is quietest. An expired passport discovered during planting season leaves almost no time for standard processing.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "Central SD Airport Strategy — HON, ABR, FSD",
        subtitle: "Three airports serving central South Dakota with varying connectivity",
        description: "Huron Regional Airport (HON) primarily serves general aviation with limited commercial options. For scheduled commercial flights, Huron residents typically use Aberdeen Regional Airport (ABR, 90 miles north via US-281) or Sioux Falls Regional Airport (FSD, 120 miles southeast via US-14 and I-29). Both connect to Minneapolis–St. Paul (MSP), Chicago O'Hare (ORD), and Denver (DEN) — all major international gateways. The drive time to either airport is 1.5–2 hours.",
        tip: "Factor in the 1.5–2 hour drive to a commercial airport when calculating your passport timeline. A delayed passport means a missed connection at ABR or FSD and cascading international flight problems.",
      },
      {
        icon: "ri-building-2-line",
        title: "South Dakota State Fair International Connections",
        subtitle: "One of the largest state fairs in the region draws global participants",
        description: "The South Dakota State Fair in Huron is one of the premier agricultural expositions in the Upper Midwest, drawing exhibitors and livestock judges from Canada, Australia, New Zealand, and Europe. Huron-based fair organizers, extension agents, and agricultural professionals frequently travel abroad for pre-fair scouting trips, international livestock judge recruitment, and post-fair exchange programs. These trips often require expedited passport processing due to short planning windows.",
        tip: "State Fair international travel planning should begin 3–4 months in advance. Pre-fair scouting trips to Australia, New Zealand, or Europe typically occur in spring (March–May) — start your passport process in January.",
      },
      {
        icon: "ri-road-map-line",
        title: "Central South Dakota Rural Travel Patterns",
        subtitle: "Long distances to everything — but that's why we exist",
        description: "Huron's central location means everything is far — the nearest passport agency (Minneapolis) is 350 miles, the nearest major international airport (MSP) is nearly 400 miles, and even the nearest acceptance facilities with reliable appointment availability are 50–90 miles away. This geographic reality is exactly why our remote courier service exists — Huron residents should never have to drive six hours for a passport.",
        tip: "Use our overnight shipping service to eliminate the transit penalty of central South Dakota's location. Documents shipped from Huron reach our processing center as fast as those from Sioux Falls.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Huron & Cross-Border Canada Travel",
      description: "Huron's central South Dakota location puts Regina, Saskatchewan within a day's drive (approximately 550 miles north). Canadian farm shows, fishing trips to Manitoba and Saskatchewan lakes, and cross-border agricultural equipment sourcing create regular passport and passport card demand. Many Huron residents use passport cards for these land-border crossings.",
    },
  },
  destinations: {
    title: "Where Huron Travelers Go — And Why Passports Get Urgent",
    intro: "Huron's unique mix of agricultural trade, State Fair international connections, and central South Dakota geography creates diverse passport needs. Here are the most common destinations and the urgency patterns we see.",
    stats: [
      { stat: "45%", label: "of Huron expedited requests are agricultural trade show or equipment sourcing-related" },
      { stat: "2–6 Weeks", label: "average lead time from ag trade show registration to international departure" },
      { stat: "Aug–Sep", label: "peak season when State Fair preparations and last-minute summer travel intersect" },
      { stat: "350 Miles", label: "distance Huron residents avoid by using our courier instead of driving to the Minneapolis agency" },
    ],
    destinations: [
      { name: "Canada", context: "Farm Progress Show in Regina, Ag in Motion near Saskatoon, fishing trips to Manitoba and Saskatchewan", urgency: "Summer show season June–July, passport card popular for land crossings", icon: "ri-map-pin-2-line" },
      { name: "Germany", context: "Agritechnica in Hannover, agricultural machinery trade fairs, equipment sourcing trips", urgency: "Trade show dates fixed — 3–6 weeks advance notice", icon: "ri-map-pin-2-line" },
      { name: "Australia & New Zealand", context: "SD State Fair livestock judge recruitment, agricultural exchange programs, family connections", urgency: "Spring scouting trips (March–May) with 4–8 week planning", icon: "ri-map-pin-2-line" },
      { name: "Norway & Sweden", context: "Scandinavian heritage travel strong in central SD, genealogical tourism, family visits", urgency: "Summer heritage trips booked 2–3 months in advance", icon: "ri-map-pin-2-line" },
      { name: "Mexico & Caribbean", context: "Winter getaways from South Dakota cold, Cancun resorts, agricultural conferences in Mexico", urgency: "January–March resort deals booked 3–4 weeks out", icon: "ri-map-pin-2-line" },
      { name: "Italy & Netherlands", context: "European agricultural equipment manufacturers, dairy industry connections, food processing technology", urgency: "Equipment sourcing trips with 2–4 weeks notice", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other South Dakota Service Areas",
    crossLinksDesc: "We serve travelers across the Mount Rushmore State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Sioux Falls", route: "/sioux-falls" },
      { name: "Rapid City", route: "/rapid-city" },
      { name: "Aberdeen", route: "/aberdeen-sd" },
    ],
  },
  photoLocations: [
    { name: "Huron Main Post Office", address: "410 Dakota Ave S, Huron, SD 57350", hours: "Mon–Fri 9 AM – 4 PM", website: "https://tools.usps.com/find-location.htm", websiteLabel: "USPS Location" },
    { name: "Lewis Drug — Huron", address: "2150 Dakota Ave S, Huron, SD 57350", hours: "Mon–Fri 8 AM – 9 PM, Sat–Sun 9 AM – 6 PM", website: "https://www.lewisdrug.com/", websiteLabel: "Lewis Drug" },
    { name: "Walmart Supercenter — Huron", address: "2791 Dakota Ave S, Huron, SD 57350", hours: "Daily 7 AM – 11 PM", website: "https://www.walmart.com/store/finder", websiteLabel: "Walmart Photo" },
    { name: "Walgreens — Huron", address: "1985 Dakota Ave S, Huron, SD 57350", hours: "Daily 8 AM – 10 PM", website: "https://www.walgreens.com/storelocator", websiteLabel: "Walgreens Photo" },
    { name: "UPS Store — Huron", address: "1735 Dakota Ave S, Huron, SD 57350", hours: "Mon–Fri 8 AM – 6 PM, Sat 9 AM – 2 PM", website: "https://www.theupsstore.com/tools/find-a-store", websiteLabel: "UPS Store" },
    { name: "Aberdeen Post Office", address: "1020 S 5th St, Aberdeen, SD 57401", hours: "Mon–Fri 9 AM – 4:30 PM", website: "https://tools.usps.com/find-location.htm", websiteLabel: "USPS Location" },
    { name: "Walgreens — Aberdeen", address: "215 6th Ave SE, Aberdeen, SD 57401", hours: "Daily 8 AM – 10 PM", website: "https://www.walgreens.com/storelocator", websiteLabel: "Walgreens Photo" },
    { name: "FedEx Office — Sioux Falls", address: "3400 W 49th St, Sioux Falls, SD 57106", hours: "Mon–Fri 7:30 AM – 9 PM, Sat 9 AM – 6 PM", website: "https://www.fedex.com/en-us/location.html", websiteLabel: "FedEx Office" },
  ],
  dmvLocations: [
    {
      name: "Huron DPS Driver License Exam Station",
      address: "410 3rd St SW, Huron, SD 57350",
      hours: "Mon–Fri, 7:00 AM – 5:30 PM",
      note: "Driver licenses, REAL ID, written and road tests. Appointment recommended.",
      featured: true,
    },
    {
      name: "Aberdeen DPS Driver License Exam Station",
      address: "420 S Roosevelt St, Aberdeen, SD 57401",
      hours: "Mon–Fri, 7:00 AM – 5:30 PM",
      note: "Full-service DPS driver license office serving northeastern South Dakota. REAL ID available. Appointment strongly recommended.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "HON",
      name: "Huron Regional Airport",
      distance: "About 3 miles north of downtown Huron",
      address: "39344 170th St, Huron, SD 57350",
      note: "General aviation airport serving Huron and Beadle County. Limited commercial service — most travelers use ABR or FSD for scheduled flights.",
      flightUrl: "https://www.huronsd.gov/airport",
      flightLabel: "Huron Regional Airport",
      featured: true,
    },
    {
      code: "ABR",
      name: "Aberdeen Regional Airport",
      distance: "About 90 miles north of Huron via US-281",
      address: "4740 6th Ave SE, Aberdeen, SD 57401",
      note: "Regional airport with daily connections to MSP (Minneapolis–St. Paul) — a major international gateway. About a 90-minute drive from Huron.",
      flightUrl: "https://www.aberdeen.sd.us/174/Aberdeen-Regional-Airport",
      flightLabel: "ABR Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the South Dakota Department of Health Vital Records. Online, mail, or in-person options available.",
      url: "https://doh.sd.gov/records/stillbirth.aspx",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through SD Department of Health Vital Records. Required for estate and legal matters.",
      url: "https://doh.sd.gov/records/stillbirth.aspx",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Beadle County Register of Deeds. Certified copies available for name changes and legal purposes.",
      url: "https://beadle.sdcounties.org/departments/register-of-deeds",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Beadle County Clerk of Courts. Required for name change passport corrections.",
      url: "https://beadle.sdcounties.org/departments/clerk-of-courts",
    },
  ],
};